import { Maybe, PerformanceStatusEnum, ResourceTypeEnum } from '@/types/schema';

export interface Content {
  duration?: Maybe<number>;
  type?: ResourceTypeEnum;
  performance?: Maybe<{
    status?: Maybe<PerformanceStatusEnum>;
    progress?: Maybe<number>;
    estimatedTimeSpent?: Maybe<number>;
    enrolmentInfo?: Maybe<{
      dueDate?: Maybe<string>;
    }>;
  }>;
}

export enum ContentOverdueDueEnum {
  Due = 'DUE',
  Overdue = 'OVERDUE',
  Completed = 'COMPLETED',
  DueShort = 'DUE_SHORT',
}

export enum ContentPerformanceStatusEnum {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
}

export type StatusTranslationKeys = {
  [key in ContentPerformanceStatusEnum]?: string;
};

export type OverdueTranslationKeys = {
  [key in ContentOverdueDueEnum]?: string;
};
